"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Config = /** @class */ (function () {
    function Config() {
    }
    /**
     * We use injection token for optional providing.
     */
    Config.coreConfigPathToken = new core_1.InjectionToken('Core navigation config file token');
    return Config;
}());
exports.Config = Config;
//# sourceMappingURL=config.js.map